:host {
    display: flex;
    flex-direction: column;
    gap: 8px;
    user-select: none;

    wf-award {
        width: var(--vx-awards-width, 75px);
        height: var(--vx-awards-height, 75px);

        @media screen and (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait),
        (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape),
        (min-width: 840px) and (orientation: portrait),
        (min-width: 1280px) and (orientation: landscape) {
            width: 100px;
            height: 100px;
        }

        &.sizing-s {
            width: 70px;
            height: 70px;

            @media screen and (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait),
            (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape),
            (min-width: 840px) and (orientation: portrait),
            (min-width: 1280px) and (orientation: landscape) {
                width: 75px;
                height: 75px;
            }
        }
    }
}
